import axios from "../../config/axiosConfig";
import { getGrayJobIssueTransactionTakaNo } from './gray-job-issue-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_GRAY_JOB_ISSUE, GET_GRAY_JOB_ISSUES, GRAY_JOB_ISSUE_REQUEST, UPDATE_GRAY_JOB_ISSUE, DELETE_GRAY_JOB_ISSUE,
  GRAY_JOB_ISSUE_REQUEST_FAILURE, SET_RECEIVE_RETURN_DETAIL_BY_ID, GET_WEAVER_PARTIES } from "../types";

export const getGrayJobIssues = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/gray-job-issue/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_ISSUES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createGrayJobIssue = (grayJobIssue) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const newGrayJobIssue = {
        ...grayJobIssue
      };
      return axios.post("/gray-job-issue/add", newGrayJobIssue,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_GRAY_JOB_ISSUE, payload: response.data });
          dispatch(getGrayJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_ISSUE_REQUEST_FAILURE,
            error: "Gray Job Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateGrayJobIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.put("/gray-job-issue/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GRAY_JOB_ISSUE,
            payload: { id, data: response.data },
          });
          dispatch(getGrayJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_ISSUE_REQUEST_FAILURE,
            error: "Gray Job Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteGrayJobIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/gray-job-issue/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GRAY_JOB_ISSUE, id: id });
          dispatch(getGrayJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getGrayJobReceiveReturnDetailByIssueId = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.get(`/gray-job-issue/get-receive-return-by-id/${id}`,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
        if (response.data) {
          dispatch({ type: SET_RECEIVE_RETURN_DETAIL_BY_ID, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const printEwayGrayJobIssue = (ewaybillNumber) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: SALES_BILL_REQUEST });
      console.log("Printing E-Way Bill with number:", ewaybillNumber);
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber };
      console.log("Params for printing E-Way Bill:", params);
      return axios.get("/gray-job-issue/print-eway-bill", { params }).then((response) => {
        return response.data;
        // if (response.data) {
        //   dispatch({ type: GET_SALES_BILLS, payload: response.data });
        // }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const generateEwayGrayJobIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      // let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      // console.log('params', params);
      // let data = {};
      
      return axios.get(`/gray-job-issue/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_GRAY_JOB_ISSUE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEwayGrayJobIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.post(`/gray-job-issue/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GRAY_JOB_ISSUE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getWeaverParties = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/gray-job-issue/get-weaver-parties", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WEAVER_PARTIES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};